import { query } from '@/services/down/targetFields';

export default {
  namespace: 'targetFields',
  state: {},

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
  },
};
